<template>
  <div>
    <p>Notification Guidelines</p>
    <p>
      <span>{{ message }}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.Vue-Toastification__toast-component-body p {
  margin: 0;
}
</style>
